import React from "react";
import "../assets/styles/registerPopUp.css";
import driverAppIcon from "../assets/images/driverAppIcon.svg";
import googlePlayIcon from "../assets/images/googlePlayIcon.svg";
import AppstoreIcon from "../assets/images/AppstoreIcon.svg";
import { options } from "../constants";
import { useSelector } from "react-redux";

const RegisterPagePopUp = () => {
  const language = useSelector((state) => state.language);
  return (
    <div className="register-popup">
      <div className="register-popup-content">
        <span
          className="register-popup-content-span-2"
          style={{
            marginTop: "20px",
          }}
        >
          {options[language].lowComisions}
        </span>
        <span className="register-popup-content-span-2">{options[language].moreReve}</span>
        {/* <span
          className="register-popup-content-span-3"
          style={{
            marginTop: "30px",
          }}
        >
          {options[language].forEveryRide}
        </span>
        <span className="register-popup-content-span-3">
          <span className="register-popup-content-span-4">0.30</span>
          <span className="register-popup-content-span-5"> AZN</span> {options[language].payComision}
        </span> */}
        <span
          className="register-popup-content-span-3"
          style={{
            marginTop: "90px",
          }}
        >
          <span className="register-popup-content-span-4">+ 2000</span>
          <span className="register-popup-content-span-5"> AZN</span> - {options[language].addiR}
        </span>
        <div
          className="type-info"
          style={{
            marginTop: "20px",
          }}
        >
          <img src={driverAppIcon} alt="driver app icon" />
          <span>{options[language].bidDriver}</span>
        </div>
        <div className="type-urls">
          <a
            href="https://play.google.com/store/apps/details?id=com.bidriver"
            target="_blank"
          >
            <img src={googlePlayIcon} alt="google play icon" />
          </a>
          <a
            href="https://apps.apple.com/az/app/bid-driver/id6497953366"
            target="_blank"
          >
            <img src={AppstoreIcon} alt="app store icon" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default RegisterPagePopUp;
